import {Pipe, PipeTransform} from '@angular/core';
import {ThresholdUtil} from "../../../util/threshold";

/*
 * converts the threshold end time
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | thresholdEndTime
 * Example:
 *   {{ 30:00 | thresholdEndTime }}
 *   formats to: 29:59
*/
@Pipe({name: 'thresholdEndTime'})
export class ThresholdEndTimePipe implements PipeTransform {

  constructor (private thresholdUtil: ThresholdUtil){}

  transform(value: string): string {
    return this.thresholdUtil.convertBlockToEndTimeDisplay(this.convertEndTimeToBlock(value))
  }

  convertEndTimeToBlock(end: string) {
    if (!end)
      return ThresholdUtil.END_TIME;

    let a: string[] = end.split(":");

    if (a.length < 2)
      return ThresholdUtil.END_TIME;

    let hours = parseInt(a[0]);
    let minutes = a[1];

    if (hours >= ThresholdUtil.START_TIME && hours <= ThresholdUtil.END_TIME) {
      return minutes == '59' ? (hours) : (hours - 1);
    }

    return ThresholdUtil.END_TIME;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/things/threshold/thresholdEndTime.pipe.ts